
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5h8br", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e331075572d5c623$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e331075572d5c623$export$2e2bcd8739ae039 = {
    'people.menu.renotify.flag.description': "We're emailing everyone a reminder. This can take up to a minute.",
    'people.menu.renotify.flag.description.confluence': 'Remind teammates',
    'people.menu.renotify.flag.title': 'Sending reminders',
    'people.menu.renotify.flag.title.confluence': 'Resending invite email',
    'people.menu.renotify.menu.description': "{userCount, plural, one {# person hasn't} other {# people haven't}} accepted their {product} invite. See who's missing and send them a reminder.",
    'people.menu.renotify.menu.description.confluence': "Some people haven't accepted their Confluence invite. See who's missing and send them a reminder.",
    'people.menu.renotify.menu.dismiss': 'Dismiss',
    'people.menu.renotify.menu.dismiss.confluence': 'Not now',
    'people.menu.renotify.menu.remind': 'Remind team members',
    'people.menu.renotify.menu.remind.confluence': 'Remind teammates',
    'people.menu.renotify.menu.title': 'Is everyone on board?',
    'people.menu.renotify.modal.copied': 'Link copied',
    'people.menu.renotify.modal.copy': 'Copy invite link',
    'people.menu.renotify.modal.description': 'We can email a reminder to the missing members, or you can share the invite link yourself.',
    'people.menu.renotify.modal.description.confluence': 'Send the invite email again, or copy and share the invite link.',
    'people.menu.renotify.modal.dismiss': 'Cancel',
    'people.menu.renotify.modal.resend': 'Send reminder',
    'people.menu.renotify.modal.resend.confluence': 'Resend invite',
    'people.menu.renotify.modal.title': 'Remind missing members',
    'people.menu.renotify.modal.title.confluence': 'Remind missing teammates',
    'ptc.pm.collaborators.title': 'Your Collaborators',
    'ptc.pm.error-heading': "Something\u2019s gone wrong",
    'ptc.pm.error-image-alt-text': 'A broken robot and a number of people busy fixing it.',
    'ptc.pm.error-text': "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
    'ptc.pm.num-members': '{memberCount, plural, one {# member} other {# members} }',
    'ptc.pm.people': 'People',
    'ptc.pm.teams': 'Teams',
    'ptc.pm.view-your-profile': 'View your profile',
    'ptc.pm.your-teams.title': 'Your Teams'
};

});


//# sourceMappingURL=en.1f4031cb.js.map
